export const AdobeAnalyticsConst = {
  SITE_DETAILS: { name: 'Customer Engagement Suite' },
  FORM: {
    NAME: 'User Registration',
    TYPE: 'Registration',
    START: 'formStart',
    STEP: 'formStep',
    SUCCESS: 'formSuccess',
    USER_REGISTRATION: 'userRegistration',
  },
  EVENTS: {
    LINKCLICK: 'defaultLinkClick',
    ONSITESEARCH: 'onsiteSearch',
    DEFAULTPAGEVIEW: 'defaultPageView',
    PAGESCROLL: 'scroll',
    SECTION_HIGHLIGHT: 'sectionHighlight',
    SIGN_OUT: 'signOut',
    AUTH_CHECK_RECOVERED: 'authCheckRecovered',
    AUTH_CHECK_FAILURE: 'authCheckFailure',
  },
  POSITIONS: {
    NAVIGATION_BAR: 'Navigation Bar',
    NAVIGATION_TABS: 'Navigation Tabs',
    NEWSFEED_TABLE: 'Newsfeed Table',
    HCPS_TABLE: 'HCPS Table',
    APPLICATION_HEADER: 'Application Header',
    NEWSFEED_SEARCH: 'Newsfeed Search',
    HCP_OVERVIEW: 'Healthcare Professional Overview',
    PARTNER_SCORE_FILTER: 'Partner Score Filter',
    COMPETITOR_INSIGHTS_PARTNER_SCORE_TAB: 'Competitor Insights: Partner Score',
    PARTNER_SCORE_TAB: 'PS-aggregated: Partner Score',
    CHANNEL_FOCUS_TABS: 'Channel Focus Tabs',
    GLOBAL_BENCHMARKING_TABS: 'Global Benchmarking Tabs',
    COVERAGE_BY_SEGMENTATION_TABS: 'Coverage by Segmentation Tabs',
    EMAIL_CAMPAIGN_DETAIL_VIEW_TABS: 'Email Campaign Detail View Tabs',
    PAGE_HEADER_TOOLTIPS: 'Page Header Tooltips',
    PERSONALISATION_SCOREBOX_TOOLTIP: 'personalisation_scorebox_tooltip',
    SCROLLABLE_CONTAINER: 'Scrollable Container',
    EVOLUTION_DIAGRAM_TABS: 'Evolution Diagram Tabs',
    KEY_METRICS_TABS: 'Key Metrics Tabs',
    EVENT_DETAIL_VIEW_TABS: 'Event Detail View Tabs',
    FREQUENCY_INTERACTIONS_ENGAGEMENT_CHANNEL_BREAKDOWN_BUTTON:
      'Frequency Interactions Engagement: Channel Breakdown Button',
    AGGREGATED_CONSENT_KEY_METRICS_TABS: 'Aggregated Consent Key Metrics Tabs',
    AGGREGATED_CONSENT_BY_SEGMENTATION_TABS: 'Aggregated Consent By Segmentation Tabs',
    WEBSITE_REGIONS_COMPARISON_TABS: 'Website Regions Comparison Tabs',
    COMPETITOR_ANALYSIS_TAB_SWITCHER: 'Competitor Analysis Tab Switcher',
    PERSONIFY_NEWSLETTER_BANNER: 'Personify Newsletter Banner',
  },
  LINK_TYPES: {
    BUTTON: 'Button',
    TABS: 'Tabs',
    LINK: 'Link',
  },
  BUTTON_TEXT: {
    SHOW_FILTERS: 'Show Filters',
    SEARCH_HCPS: 'Search Healthcare Professionals',
    FAVORITES: 'Favorites heart icon click',
    PARTNERSHIP_TYPE: 'Select partnership type',
    SCROLL_LEFT: 'Scroll Left',
    SCROLL_RIGHT: 'Scroll Right',
    FAVORITES_NAVIGATION: 'Favorites Navigation',
  },
  PAGE_IDENTIFIER: {
    DISCLAIMER: 'Disclaimer',
    USER_PREFERENCES: 'User Preferences',
    COOKIES_CONSENT_BANNER: 'Cookies Consent Banner',
    CUSTOMER_FOCUS: 'Customer Focus',
    PERSONALIZED_ENGAGEMENT: 'Personalized Engagement',
    CHANNEL_FOCUS: 'Channel Focus - All channels',
    CHANNEL_FOCUS_1TO1VISITS: 'Channel Focus - 1to1visit',
    CHANNEL_FOCUS_EMAILS: 'Channel Focus - Emails',
    CHANNEL_FOCUS_EVENT: 'Channel Focus - Events',
    CHANNEL_FOCUS_WEBSITE: 'Channel Focus - Website',
    MY_HCPS: 'My Healthcare Professionals',
    SEARCH_HCPS: 'Search Healthcare Professionals',
    HCP_OVERVIEW: 'Healthcare Professional Overview',
    HCP_ENGAGEMENT: 'Healthcare Professional Engagement',
    HCP_SEGMENTATION: 'Healthcare Professional Segmentation',
    INSIGHT: 'Healthcare Professional Insight',
    PARTNER_SCORE_HCP: 'Healthcare Professional Partner Score',
    PARTNER_SCORE_COMPETITOR: 'Partner Score Competitor analysis',
    CSAT_SCORE_COMPETITOR: 'Csat score Competitor analysis',
    CES_SCORE_COMPETITOR: 'Effort score Competitor analysis',
    NPS_SCORE_COMPETITOR: 'Net promoter score Competitor analysis',
    PARTNER_SCORE: 'Partner Score',
    CSAT_SCORE: 'Csat score',
    CES_SCORE: 'Effort score',
    NPS_SCORE: 'Net promoter score',
    GLOBAL_BENCHMARKING: 'Global Benchmarking - 1to1 visits',
    GLOBAL_BENCHMARKING_EMAIL: 'Global Benchmarking - email',
    GLOBAL_BENCHMARKING_EVENTS: 'Global Benchmarking - events',
    GLOBAL_BENCHMARKING_WEBSITE: 'Global Benchmarking - website',
    INSIGHTS: 'Insights',
    AGGREGATED_SCIENTIFIC_INFORMATION: 'Aggregated Scientific Information',
    SALES: 'Sales',
    MANAGED_PREFERENCES: 'Managed Preferences',
    AGGREGATED_CONSENT: 'Aggregated Consent',
    CLINICAL_TRIALS: 'Clinical Trials',
    CLINICAL_TRIALS_SUMMARY: 'Clinical Trials - Trial Summary',
    CLINICAL_TRIALS_OUTCOMES: 'Clinical Trials - Trial Outcomes',
    CLINICAL_TRIALS_OBJECTIVES: 'Clinical Trials - Trial Objectives',
    CLINICAL_TRIALS_PATIENT_POPULATION: 'Clinical Trials - Patient Population',
    CLINICAL_TRIALS_TREATMENT_PLANS: 'Clinical Trials - Treatment Plans',
    CLINICAL_TRIALS_RESULTS: 'Clinical Trials - Results',
    CLINICAL_TRIALS_SUPPORTING_URLS: 'Clinical Trials - Supporting URLs',
    HCP_PERSONALIZED_ENGAGEMENT: 'Healthcare Professional Personalized Engagement',
    SIGN_OUT: 'Sign Out',
  },
  LINKCLICK_NAMES: {
    DASHBOARD_NAVIGATION_TABS: 'Tabs in Dashboard Navigation',
    SEARCH_HCPS: 'Search Healthcare Professionals',
    SHOW_FILTERS: 'Show Filters',
    HCP_CLICK: 'Click on Healthcare Professionals',
    NEWSFEED_TITLE: 'Newsfeed Title Click',
    FILTERS_TYPE: 'Filter Type Click',
    SOCIAL_ICONS: 'Social Icons Click',
    HCP_ROLES_AND_LOCATION: 'Healthcare Professional Roles and Location Click',
    SPECIALITY_AREA: 'Healthcare Professional Specialty Area Click',
    RECENTLY_VIEWED: 'Recently Viewed Click',
    FAVORITES: 'Favorites Click heart icon',
    FAVORITES_NAVIGATION: 'Favorites Navigation Click',
    SEE_CONFERENCE_DETAILS_CLICK: "Click 'See Details' for Conference",
    PARTNER_SCORE_NAVIGATION_TABS: 'Tabs in Partner Score Navigation',
    PARTNER_SCORE_FILTERS: 'Filters in Partner Score Navigation',
    COMPETITOR_INSIGHTS_PARTNERSHIP_FILTER_OPEN: 'PS-aggregated/Vcomments-Partnership/filter_open',
    COMPETITOR_INSIGHTS_PARTNERSHIP_FILTER_COLLAPSED: 'PS-aggregated/Vcomments-Partnership/filter_collapsed',
    CHANNEL_FOCUS_TABS: 'Channel Focus Navigation Tabs',
    GLOBAL_BENCHMARKING_TABS: 'Global Benchmarking Navigation Tabs',
    COVERAGE_BY_SEGMENTATION_TABS: 'Coverage by Segmentation Tabs',
    EMAIL_CAMPAIGN_DETAIL_VIEW_TABS: 'Email Campaign Detail View Tabs',
    EVOLUTION_DIAGRAM_TABS: 'Evolution Diagram Tabs',
    KEY_METRICS_TABS: 'Key Metrics Tabs',
    SIGN_OUT_BUTTON: 'Sign Out Button Click',
    PAGE_HEADER_TOOLTIPS: 'Page Header Tooltips Click',
    PERSONALISATION_SCOREBOX_TOOLTIP: 'personalisation_scorebox_tooltip',
    SCROLLABLE_NAVIGATION: 'Scrollable Navigation',
    EVENT_DETAIL_VIEW_TABS: 'Event Detail View Tabs',
    FREQUENCY_INTERACTIONS_ENGAGEMENT_CHANNEL_BREAKDOWN_BUTTON:
      'Frequency Interactions Engagement: Channel Breakdown Button',
    AGGREGATED_CONSENT_KEY_METRICS_TABS: 'Aggregated Consent Key Metrics Tabs',
    AGGREGATED_CONSENT_BY_SEGMENTATION_TABS: 'Aggregated Consent By Segmentation Tabs',
    WEBSITE_REGIONS_COMPARISON_TABS: 'Website Regions Comparison Tabs',
    APP_LAUNCHER_TAB: 'APP_LAUNCHER_TAB',
    USER_MENU_TAB: 'USER_MENU_TAB',
    COMPETITOR_ANALYSIS_TAB_SWITCHER: 'Competitor Analysis Tab Switcher',
    PERSONIFY_NEWSLETTER_SIGNUP: 'Personify Newsletter Sign-Up',
  },
  HCP_OVERVIEW_SOCIAL_ICONS: {
    EMAIL: 'Email',
    PHONE: 'Phone',
    BLUESKY: 'Bluesky',
    LINKEDIN: 'LinkedIn',
    LINE: 'Line',
    PROFILE_ICON: 'Profile Icon',
  },
  HCP_SPECIALITY_AREA: {
    HCP_PROFILE_PAGE: 'Healthcare Professional Profile Page',
    HCO_PROFILE_PAGE: 'Healthcare Organization Profile Page',
    HCO_360_PAGE: 'Healthcare Organization 360 Profile Page',
    PUBMED_RESULT: 'PubMed Result',
    ROCHE_SPONSORED_TRIALS: 'Roche Sponsored Trials',
  },
};
